import { useAppDispatch } from 'app/hooks';
import FooterMenu from 'components/Commons/FooterMenu';
import Header from 'components/Commons/Header';
import AuthPage from 'features/auth/pages/AuthPage';
import ChangePasswordPage from 'features/auth/pages/ChangePasswordPage';
import useUserDetail from 'hooks/useUserDetail';
import { useState } from 'react';
import TransactionModal from '../components/Modals/TransactionModal';
import StreamerPlatform from '../components/StreamerPlatform';
import { onChangeAuthPage, setShowSubMenu } from '../homeSlice';

const StreamerPage = () => {
  const { isUserLoggedIn, currentUser } = useUserDetail();
  const [isShowChangePasswordForm, setIsShowChangePasswordForm] = useState<boolean>(false);
  const dispatch = useAppDispatch();

  const closeForm = (): void => {
    dispatch(onChangeAuthPage(-1));
    dispatch(setShowSubMenu(false));
    setIsShowChangePasswordForm(false);
  };
  const onShowChangePasswordPage = () => {
    if (isUserLoggedIn) setIsShowChangePasswordForm(true);
  };

  return (
    <div className="casino-page relative">
      <i className="version">Version 1.0</i>

      <div className={`main-container`}>
        <Header isStreaming onShowChangePasswordPage={onShowChangePasswordPage} />
        <div className="casino-container">
          <StreamerPlatform platform="Youtube" />
          <StreamerPlatform platform="Twitch" />
          <StreamerPlatform platform="Tiktok" />
        </div>
      </div>
      <FooterMenu
        isUserLogin={isUserLoggedIn}
        onShowChangePasswordPage={onShowChangePasswordPage}
        isStreaming
      />
      <ChangePasswordPage isShow={isShowChangePasswordForm} closePage={closeForm} />
      <AuthPage />
      <TransactionModal />
    </div>
  );
};

export default StreamerPage;
